import { extractOptionValue } from './formatRefereeHelpers';

export const formatIndependentAssessorData = (data, titlesTypes = {}) => {
  const formattedData = { ...data };
  const date = new Date();

  const refereeIdentifiers = ['Seven', 'Eight', 'Nine'];

  refereeIdentifiers.forEach((identifier) => {
    const refereeValue = formattedData[`referee${identifier}`];
    const parsedRefereeValue = parseInt(refereeValue);

    if (!Number.isNaN(parsedRefereeValue)) {
      formattedData[`referee${identifier}TypeId`] = parsedRefereeValue;

      const refereeTypeId = formattedData[`referee${identifier}TypeId`];
      const nonAasRefereeId =
        formattedData[`nonAasReferee${identifier}Id`] ?? null;

      if (
        typeof refereeTypeId === 'number' &&
        refereeTypeId === 0 &&
        typeof nonAasRefereeId === 'object' &&
        nonAasRefereeId?.value === 0
      ) {
        formattedData[`newNonAasReferee${identifier}`] = {
          titleId: parseInt(formattedData[`referee${identifier}TitleId`]),
          name: formattedData[`referee${identifier}Name`],
          lastName: formattedData[`referee${identifier}LastName`],
          email: formattedData[`referee${identifier}Email`],
          countryId: formattedData[`referee${identifier}CountryId`]?.value,
          organisation:
            formattedData[`referee${identifier}Organisation`] &&
            formattedData[`referee${identifier}Organisation`] !== ''
              ? formattedData[`referee${identifier}Organisation`]
              : formattedData[
                  `referee${identifier}EmailEducationalInstitution`
                ],
          memberships: formattedData[`referee${identifier}Memberships`],
          label: `${titlesTypes[parseInt(formattedData[`referee${identifier}TitleId`])] ? `${titlesTypes[parseInt(formattedData[`referee${identifier}TitleId`])]} ` : ''}${formattedData[`referee${identifier}Name`]} ${formattedData[`referee${identifier}LastName`]} (${formattedData[`referee${identifier}Email`]})`,
          publishedAt: date.toISOString().split('T')[0],
        };
      }

      const fellowIdKey = `referee${identifier}FellowId`;
      const nonAasIdKey = `nonAasReferee${identifier}Id`;
      formattedData[fellowIdKey] = extractOptionValue(
        formattedData,
        fellowIdKey,
      );
      formattedData[nonAasIdKey] = extractOptionValue(
        formattedData,
        nonAasIdKey,
      );
    }
  });

  [formattedData.publishedAt] = date.toISOString().split('T');

  return formattedData;
};
